import { render, staticRenderFns } from "./personal-achievement-revision.vue?vue&type=template&id=76e83613&"
import script from "./personal-achievement-revision.vue?vue&type=script&lang=js&"
export * from "./personal-achievement-revision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports